module.exports = __webpack_public_path__ + "img/2.9c12c9f7.jpg";